module.exports = __webpack_public_path__ + "static/media/house_baratheon.9b80d4f8.png";